import React from 'react'
import Icon from "../Icon/Icon";

export const ExportTableButton = ({onClick, icon, title}) => {

  return (
      <button className="btn btn-info pull-right" onClick={onClick && onClick} title={title}>
        <Icon icon={icon}/>
      </button>
  )
}



// WEBPACK FOOTER //
// ./src/component/Button/ExportTableButton.js